import { useEffect } from 'react';
import useDatadogRum from './use-datadog-rum.js';
export default function useSessionReplayRecording({ enabled, sessionReplayRecording, }) {
    const rum = useDatadogRum();
    useEffect(() => {
        if (!enabled || !sessionReplayRecording) {
            return;
        }
        rum.startSessionReplayRecording();
        return () => {
            rum.stopSessionReplayRecording();
        };
    }, [enabled, rum, sessionReplayRecording]);
}
//# sourceMappingURL=use-session-replay-recording.js.map